/**
 * Indicates presence of a resumable error during the update.
 */
export const updateAgainCode = '[EAGAIN]';
